import { DIFFERENT_FUNCTION_CARDS } from '@/pages/home/constants';
import DifferentFunctionCard from '@/pages/home/components/DifferentFunctionCard';

/**
 * 차별화 기능 배너 컴포넌트
 * @returns JSX.Element
 */
const DifferentFunctionBanner = () => {
	return (
		<section className="main-different-feature main-section">
			<div className="main-different-feature-inner">
				<div className="title-group">
					<p className="sub">Special of ‘STELLA’</p>
					<p className="title">Stella의 차별화 포인트</p>
				</div>
				<ul className="item-group">
					<DifferentFunctionCard items={[...DIFFERENT_FUNCTION_CARDS]} />
				</ul>
			</div>
		</section>
	);
};

export default DifferentFunctionBanner;
